<div class="row cl-spacing-small" [formGroup]="form">
  <div class="col-4">
    <label for="input_brefix" class="form-label">Source Folder </label>
    <input id="input_brefix" type="text" formControlName="input_brefix" readonly>
    @if (form.controls.input_brefix.errors?.required) {
      <p class="invalid-feedback">This field is
      required.</p>
    }
    @if (!form.controls.input_brefix.errors) {
      <p class="valid-feedback">You can
        <a [routerLink]="'o/' + organization.id +  '/files/browse/' + form.controls.input_brefix.value  ">navigate to the source folder</a>
      </p>
    }
  </div>
  <div class="col-4">
    <label for="po_item_id" class="form-label">Encode ID<span class="required">*</span></label>
    <input id="po_item_id" type="text" formControlName="po_item_id" [pattern]="poItemIdPattern">
    @if (form.controls.po_item_id.errors?.required) {
      <p class="invalid-feedback">This field is
      required.</p>
    }
    @if (form.controls.po_item_id.errors?.pattern) {
      <p class="invalid-feedback">{{ poItemIdPatternDescription }}</p>
    }
    @if (!form.controls.po_item_id.errors) {
      <p class="valid-feedback">Name to identify the
        encoding job.
      </p>
    }
  </div>
  <div class="col-4"  (paste)="onPaste($event)">
    <label for="filename" class="form-label">Output Name @if(this.ife_format && this.ife_format.filename !== '') {<span class="required">*</span>}</label>
    <input id="filename" type="text" formControlName="filename">
    @if (form.controls.filename.errors?.required) {
      <p class="invalid-feedback">This field is
      required.</p>
    }
  </div>

</div>
